import { t, type I18nLocale } from '@ardoq/i18n';

export const defaultComponentStyleAttributeNames = [
  'icon',
  'image',
  'shape',
  'color',
];

export const getComponentStylePlaceholder = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:componentStyle.definedByModel',
    'Defined by model (auto)'
  );
